import React, { useState, useEffect, Fragment } from 'react';
import { List, Typography, Tag, Spin, Card } from 'antd';
import { Link } from 'react-router-dom';
import { LoadingOutlined } from '@ant-design/icons';
import InvoiceService from '../invoices/services';

import CardEmptyResult from 'components/common/pageComponents/CardEmptyResult';
import { PiReceiptDuotone } from 'react-icons/pi';


const OverdueInvoicesList = () => {
  const [loading, setLoading] = useState(true);
  const [overdueInvoices, setOverdueInvoices] = useState([]);

  useEffect(() => {
    fetchOverdueInvoices();
  }, []);

  const fetchOverdueInvoices = async () => {
    try {
      const response = await InvoiceService.getOverdueInvoices();
      const result = response.data;
      if (result.success) {
        setOverdueInvoices(result.data); // Access paginated data
      }
    } catch (error) {
      console.error('Error fetching overdue invoices:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Spin indicator={<LoadingOutlined spin />} />;
  }

  return (
    <Fragment>
      {overdueInvoices.length > 0 ? (
      <Card size="small">
        <List
          size="small"
          dataSource={overdueInvoices}
          renderItem={(invoice) => (
            <List.Item>
              <List.Item.Meta
                title={
                  <Link to={`/invoices/invoice-details/${invoice.id}`}>
                    {`${invoice.sale_number} due on ${invoice.extra?.dates?.formatted?.date_due}`}
                  </Link>
                }
                description={`${invoice.extra?.meta?.description}`}
              />
              <div>
                <Tag color="red">${invoice.amount_due}</Tag>
              </div>
            </List.Item>
          )}
        />
      </Card>
      ) : (
        <CardEmptyResult title="No overdue invoices" subtitle="There are no overdue invoices" icon={<PiReceiptDuotone className="fs-2 text-secondary" />} />
      )}
    </Fragment>
  );
};

export default OverdueInvoicesList;
